import React, { useEffect, useState } from "react";
import api from "../lib/api";
import Seo from "../components/Seo";
import { Loader2 } from "lucide-react";

const LegalPage = ({ slug }) => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    api.get("/legal-pages")
      .then(({ data }) => { if (alive) setPage((data || []).find((p) => p.slug === slug) || null); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [slug]);

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 sm:py-24" data-testid={`legal-page-${slug}`}>
      <Seo title={page?.title || "Informations légales"} description={`${page?.title || "Informations légales"} — École de danse L'Élan Danse`} />
      <h1 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-deep-rose mb-3">{page?.title || "Informations légales"}</h1>
      <div className="h-px w-24 bg-blush mb-10" />
      {loading ? (
        <div className="py-12 text-center text-stone-400"><Loader2 className="animate-spin inline" size={20} /></div>
      ) : page ? (
        <div className="legal-content" data-testid={`legal-body-${slug}`} dangerouslySetInnerHTML={{ __html: page.body }} />
      ) : (
        <p className="text-stone-500 italic">Cette page n'est pas encore disponible.</p>
      )}
      {page?.updatedAt ? (
        <p className="mt-12 text-xs text-stone-400">Mise à jour le {new Date(page.updatedAt).toLocaleDateString("fr-FR")}.</p>
      ) : null}
    </div>
  );
};

export default LegalPage;
